<script lang="ts" module>
	export const symbolId = "ishavskraft-icon-document";
	export const symbol = `
		<symbol id="${symbolId}" viewBox="0 0 24 24">
			<path
				d="M9 13H15C15.2833 13 15.521 12.904 15.713 12.712C15.905 12.52 16.0007 12.2827 16 12C15.9993 11.7173 15.9033 11.48 15.712 11.288C15.5207 11.096 15.2833 11 15 11H9C8.71667 11 8.47933 11.096 8.288 11.288C8.09667 11.48 8.00067 11.7173 8 12C7.99933 12.2827 8.09533 12.5203 8.288 12.713C8.48067 12.9057 8.718 13.0013 9 13ZM9 16H15C15.2833 16 15.521 15.904 15.713 15.712C15.905 15.52 16.0007 15.2827 16 15C15.9993 14.7173 15.9033 14.48 15.712 14.288C15.5207 14.096 15.2833 14 15 14H9C8.71667 14 8.47933 14.096 8.288 14.288C8.09667 14.48 8.00067 14.7173 8 15C7.99933 15.2827 8.09533 15.5203 8.288 15.713C8.48067 15.9057 8.718 16.0013 9 16ZM9 19H12C12.2833 19 12.521 18.904 12.713 18.712C12.905 18.52 13.0007 18.2827 13 18C12.9993 17.7173 12.9033 17.48 12.712 17.288C12.5207 17.096 12.2833 17 12 17H9C8.71667 17 8.47933 17.096 8.288 17.288C8.09667 17.48 8.00067 17.7173 8 18C7.99933 18.2827 8.09533 18.5203 8.288 18.713C8.48067 18.9057 8.718 19.0013 9 19ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.19667 21.0217 4.00067 20.5507 4 20V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H13.175C13.4417 2 13.696 2.05 13.938 2.15C14.18 2.25 14.3923 2.39167 14.575 2.575L19.425 7.425C19.6083 7.60833 19.75 7.821 19.85 8.063C19.95 8.305 20 8.559 20 8.825V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H6ZM18 9H14.5C14.0833 9 13.7293 8.85433 13.438 8.563C13.1467 8.27167 13.0007 7.91733 13 7.5V4H6V20H18V9Z"
				fill="currentColor"
			/>
		</symbol>`;
</script>

<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	let {
		class: classes = null,
		ariaHidden = true,
	}: {
		class?: ClassValue | null;
		ariaHidden?: boolean;
	} = $props();
</script>

<svg
	aria-hidden={ariaHidden}
	width="24"
	height="24"
	viewBox="0 0 24 24"
	xmlns="http://www.w3.org/2000/svg"
	class={classes}
	fill="currentColor"
>
	<use href="#{symbolId}" />
</svg>
